import { getApiConfig } from '../config/markets.js';

const API_URL = getApiConfig().apiUrl;

/**
 * Obtiene el OTP de un cliente dado.
 * - leadID: el id del lead de la tabla la conversación en MongoDB.
 * - Añade Authorization: Bearer <token> en las cabeceras.
 * - Retorna un string con la url del OTP.
 */
export async function sendOtpToClient(id) {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No se encontró token de autenticación');
    }

    const res = await fetch(`${API_URL}/lead/otp/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
  
    if (!res.ok) {
      let errMsg = 'Error al obtener mensajes';
      try {
        const data = await res.json();
        errMsg = data.message || errMsg;
      } catch {}
      throw new Error(errMsg);
    }
  
    const otp = await res.json();
    return otp;
  }

/**
 * Obtiene el estado del lead desde Kitt
 * @param {string} whatsappId - WhatsApp ID del lead
 * @param {string} market - Mercado (opcional, se detecta automáticamente si no se proporciona)
 * @returns {Promise<Object>} - Datos del lead
 */
export async function getLeadStatus(whatsappId, market = null) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No se encontró token de autenticación');
  }

  const url = market
    ? `${API_URL}/lead/status/${whatsappId}?market=${market}`
    : `${API_URL}/lead/status/${whatsappId}`;

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!res.ok) {
    let errMsg = 'Error al obtener estado del lead';
    try {
      const data = await res.json();
      errMsg = data.error || errMsg;
    } catch {}
    throw new Error(errMsg);
  }

  const data = await res.json();
  return data;
}

/**
 * Envía un documento al cliente por WhatsApp
 * @param {string} documentType - Tipo de documento (contract, forecast, promo-conditions)
 * @param {string} email - Email del lead
 * @param {string} market - Mercado (es/it)
 * @returns {Promise<Object>} - Respuesta del servidor
 */
export async function sendLeadDocument(documentType, email, market = null, conversationId) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('No se encontró token de autenticación');
  }

  const url = market
    ? `${API_URL}/lead/document/${documentType}/${encodeURIComponent(email)}/${conversationId}?market=${market}`
    : `${API_URL}/lead/document/${documentType}/${encodeURIComponent(email)}/${conversationId}`;

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  });

  if (!res.ok) {
    let errMsg = 'Error al enviar documento';
    try {
      const data = await res.json();
      errMsg = data.error || data.message || errMsg;
    } catch {}
    throw new Error(errMsg);
  }

  const data = await res.json();
  return data;
}